export default "__VITE_ASSET__CR5Uz4Zy__"